import React from 'react';

export function LogoIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="200" height="200" rx="48" fill="#ff5e5e" />
      <g>
        <path d="M100 160C100 130 95 100 95 80C95 60 110 40 110 40" stroke="#ffffff" strokeWidth="18" strokeLinecap="round" />
        <path d="M95 120C80 115 60 100 60 80C60 65 75 50 75 50" stroke="#ffffff" strokeWidth="16" strokeLinecap="round" />
        <path d="M105 105C120 100 140 85 140 70C140 55 125 40 125 40" stroke="#ffffff" strokeWidth="16" strokeLinecap="round" />
      </g>
    </svg>
  );
}

export const LogoBadge: React.FC<{ size?: 'sm' | 'md' }> = ({ size = 'md' }) => {
  const cls = size === 'sm' ? 'w-7 h-7' : 'w-8 h-8';
  return (
    <div className={`${cls} rounded-lg overflow-hidden`}>
      <LogoIcon className="w-full h-full" />
    </div>
  );
};

export const LogoText: React.FC<{ className?: string }> = ({ className = 'text-lg' }) => (
  <span className={`${className} font-bold text-slate-900`}>
    Red<span className="text-primary-500">Coral</span>
  </span>
);
